// extracted by mini-css-extract-plugin
export default {"container":"c0-z","heading":"d0-z","links":"e0-z","copy":"f0-z","subCopy":"g0-z","linksLeft":"h0-z","linksCenter":"i0-z","linksRight":"j0-z","link":"k0-z","onlyLink":"l0-z"};